<template>
  <div>
    <div class="row filesControl" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :for="control.name + '_gui_control'"
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <b-form-textarea
          v-model="control.value"
          rows="3"
          @change="changed"
          :disabled="control.readonly"
        />
      </div>
    </div>
    <div v-else>
      <label
        :for="control.name + '_gui_control'"
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
      <div>
        <b-form-textarea
          v-model="control.value"
          rows="3"
          @change="changed"
          :disabled="control.readonly"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["control", "labelPosition"],
  methods: {
    changed(event) {
      const fbRoot = this.$instByClass(this, 'form-builder-root');
      fbRoot.setRowDataVal(this.control.propName, this.control.value);
    }
  }
};
</script>
